import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import HeaderActionButton from '~/components/buttons/HeaderActionButton';
import Header from '~/components/layout/Header';
import Screen from '~/components/layout/screens/Screen';
import ScreenContent from '~/components/layout/screens/ScreenContent';
import LoadingSpinner from '../../../../components/layout/LoadingSpinner';
import { dateFormat } from '../../../../services/date-time.service';
import { createOfficerAttendance, deleteAttendance, getAttendanceList, getOfficerAttendances, getOfficerInfo, getTrainingClearances, updateAttendance, updateWorkshop, } from '../actions/attendance.actions';
import CreateAttendanceModal from '../components/CreateAttendanceModal';
import DetailsTable from '../components/DetailsTable';
import HoursDisplayTable from '../components/DisplayTable';
import EditAttendanceModal from '../components/EditAttendanceModal';
import { formatAttendances } from '../services/attendance.services';
const AttendanceDetails = () => {
    const navigate = useNavigate();
    const [screenClearance, setScreenClearance] = useState(false);
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [displayEditModal, setDisplayEditModal] = useState(false);
    const [displayHist, setDisplayHist] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [officerName, setOfficerName] = useState('');
    const [totalHours, setTotalHours] = useState({
        total: 0,
        training: 0,
        carry: 0,
        exempt: 0,
    });
    const [attendanceActive, setAttendanceActive] = useState([]);
    const [attendanceHist, setAttendanceHist] = useState([]);
    const [modalData, setModalData] = useState({});
    const { officerId } = useParams();
    const breadcrumbs = [
        {
            title: 'Lookup',
            onClick: () => {
                navigate(-1);
            },
        },
        {
            title: 'Manage Attendance',
            onClick: () => {
                navigate(0);
            },
        },
    ];
    useEffect(() => {
        fetchClearances();
        fetchOfficerInfo();
        fetchRecords();
    }, []);
    const fetchClearances = async () => {
        const clearanceData = await getTrainingClearances();
        setScreenClearance(clearanceData.editClearance);
    };
    const fetchOfficerInfo = async () => {
        const officerData = await getOfficerInfo(officerId);
        setOfficerName(officerData.fullName);
    };
    const fetchRecords = async () => {
        const attendanceData = await getOfficerAttendances(officerId);
        const result = formatAttendances(attendanceData);
        setTotalHours({
            total: result.total,
            training: result.training,
            carry: result.carry,
            exempt: result.exempt,
        });
        setAttendanceActive(result.attendanceActive);
        setAttendanceHist(result.attendanceHist);
        setIsLoading(false);
    };
    const getEditModalData = async (attendanceData) => {
        const attendanceList = await getAttendanceList(attendanceData.workshopId);
        setModalData({
            ...attendanceData,
            startDate: dateFormat(attendanceData.startDate),
            endDate: dateFormat(attendanceData.endDate),
            editName: attendanceList.results.length === 1,
        });
        setDisplayEditModal(true);
    };
    const displayModalHandler = (attendanceData) => {
        getEditModalData(attendanceData);
    };
    const updateHandler = async ({ attendanceId, startDate, endDate, hoursLogged, comments, editWorkshop, workshopName, workshopId, }) => {
        setDisplayEditModal(false);
        await updateAttendance(attendanceId, startDate, endDate, hoursLogged, comments);
        if (editWorkshop) {
            await updateWorkshop(workshopId, workshopName);
        }
        fetchRecords();
    };
    const deleteHandler = async (id) => {
        setDisplayEditModal(false);
        await deleteAttendance(id);
        fetchRecords();
    };
    const submitHandler = async (inputData) => {
        setDisplayNewModal(false);
        await createOfficerAttendance(officerId, inputData);
        fetchRecords();
    };
    if (isLoading) {
        return _jsx(LoadingSpinner, {});
    }
    return (_jsxs(Screen, { children: [_jsx(Header, { breadcrumbs: breadcrumbs, helpLink: "training-entry", sticky: true, title: "Officer Attendance", children: screenClearance && (_jsx(HeaderActionButton, { Icon: faCirclePlus, label: "Add", onClick: () => {
                        setDisplayNewModal(!displayNewModal);
                    } })) }), _jsxs(ScreenContent, { children: [_jsxs("div", { children: [_jsx(HoursDisplayTable, { activeButtonClick: () => setDisplayHist(false), carry: totalHours.carry, displayHist: displayHist, exempt: totalHours.exempt, histButtonClick: () => setDisplayHist(true), officerName: officerName, total: totalHours.total, training: totalHours.training }), _jsx("div", { className: "mt-6", children: _jsx(DetailsTable, { attendances: displayHist ? attendanceHist : attendanceActive, disableSelection: displayHist, displayModal: displayModalHandler }) })] }), displayEditModal && (_jsx(EditAttendanceModal, { closeModal: () => setDisplayEditModal(false), deleteHandler: deleteHandler, modalData: modalData, updateHandler: updateHandler })), displayNewModal && (_jsx(CreateAttendanceModal, { closeModal: () => setDisplayNewModal(false), submitHandler: submitHandler }))] })] }));
};
export default AttendanceDetails;
